import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { programsApi, organizationsApi } from 'api';
import { useProgramPanel } from 'contexts/programPanelContext';
import { ProgramLandingPageMode, UpdateProgramContentConfigParametersPayload } from 'types/Program';
import { Link } from 'components/_new/Link';
import { Icon } from 'components/_new/Icon';
import { Tooltip } from 'components/_new/Tooltip/Tooltip';
import { Panel, PanelItem } from '../../partials/panel';

type ProgramStatusForm = {
	landingPageMode?: string;
};

export const ProgramContentConfig = () => {
	const { t } = useTranslation();
	const { data: programData, refetch: programRefetch } = useProgramPanel();

	const editModeState = useState(false);
	const form = useForm<ProgramStatusForm>({
		defaultValues: {
			landingPageMode: programData?.landingPageMode,
		},
	});

	const updateProgram = useMutation(
		(data: UpdateProgramContentConfigParametersPayload) =>
			programsApi.putProgramAdminContentConfigParameters(Number(programData?.id), data),
		{
			onSuccess: () => {
				programRefetch?.();
			},
		}
	);

	const updateOrganization = useMutation(
		({
			organizationName,
			displayName,
			language,
		}: {
			organizationName: string;
			displayName: string;
			language: string;
		}) => organizationsApi.editOrganization(organizationName, { displayName, language }),
		{
			onSuccess: () => {
				programRefetch?.();
			},
		}
	);

	const programUrl = `${process.env.REACT_APP_FRONT_URL}/${programData?.name}`;

	return (
		<Panel
			title={t('programPanel.dashboard.contentConfig.title')}
			form={form}
			staticEdit={`/program/${programData?.name}/landing-page`}
			isLoading={updateProgram.isLoading || updateOrganization.isLoading}
		>
			<>
				<PanelItem
					title={t('programPanel.dashboard.status.programUrlAddress')}
					value={programUrl}
					transformValue={({ value }) => (
						<a href={value} target="_blank" rel="noreferrer" className="underline">
							{value}
						</a>
					)}
				/>
				{/* <PanelItem
					title={t('programPanel.dashboard.status.programContentDisplayType')}
					value={programData?.landingPageMode}
					type="select"
					controller={{ control: form.control, name: 'landingPageMode' }}
					inputDropdownProps={{
						options: [
							{
								value: ProgramLandingPageMode.HTML,
								label: t('programPanel.dashboard.status.programContentDisplayAsHTML'),
								tooltip: t('programPanel.dashboard.status.programContentDisplayTooltip'),
							},
							{
								value: ProgramLandingPageMode.MODULE,
								label: t('programPanel.dashboard.status.programContentDisplayAsModules'),
							},
						],
					}}
					transformValue={({ value, label }) => (
						<div className="flex flex-row align-items-center gap-2">
							{value === ProgramLandingPageMode.HTML && (
								<Tooltip
									target="#lp-mode-tooltip"
									content={t('programPanel.dashboard.status.programContentDisplayTooltip')}
									position="bottom"
								/>
							)}
							<span id="lp-mode-tooltip">{label}</span>
							{value === ProgramLandingPageMode.MODULE && (
								<Link to={`/program/${programData?.name}/landing-page`}>
									<Icon name="pencil" iconSet="fa" iconStyle="solid" />
								</Link>
							)}
						</div>
					)}
				/> */}
			</>
		</Panel>
	);
};
